import { initFaro } from '@/lib/app/api';

if ([import.meta.env.VITE_OBSERVABILITY_ENABLED].includes('true')) {
  initFaro();
}

// 데스크톱과 목 세트가 다르다. `npm run dev:mobile:mock` · `dev:mobile:manual` 로만 켠다.
if (import.meta.env.MODE === 'mock' || import.meta.env.MODE === 'manual') {
  const mswReady = (async () => {
    try {
      if (import.meta.env.MODE === 'manual') {
        const { setupWorker } = await import('msw/browser');
        const { createMobileManualHandlers } = await import('./lib/msw/manual');
        const { recordUnhandled } = await import('@/lib/shared/api/msw/manual/unhandled');
        const worker = setupWorker(...createMobileManualHandlers());
        await worker.start({ onUnhandledRequest: (req) => recordUnhandled(req) });
      } else {
        const { worker } = await import('./lib/msw/browser');
        await worker.start({ onUnhandledRequest: 'bypass' });
      }
    } catch (error) {
      console.error('Failed to start MSW:', error);
    }
  })();

  (globalThis as Record<string, unknown>).__mswReady = mswReady;

  if (import.meta.env.MODE === 'manual') {
    // MSW 워커는 활성화 전 요청을 실제 네트워크로 흘린다. 부팅 요청이 앞지르면 기록에서 빠진다.
    const nativeFetch = window.fetch.bind(window);
    window.fetch = async (...args) => {
      await mswReady;
      return nativeFetch(...args);
    };
  }
}
